/* Everoot theme JS. No dependencies, no framework.
   Critical path only: gallery, tier selection, CTA total, sticky bar, cart.
   Everything here degrades to a working page if JS fails. */
(function () {
  'use strict';

  var money = function (cents) {
    var fmt = window.EVEROOT && window.EVEROOT.moneyFormat || '${{amount}}';
    var amt = (cents / 100).toFixed(2);
    var parts = amt.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount\s*\}\}/, parts.join('.'));
  };

  /* ---------- announcement rotator (mobile only) ---------------------- */
  function announcements() {
    var track = document.querySelector('[data-ann]');
    if (!track) return;
    var msgs = track.querySelectorAll('.ann__msg');
    if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () {
      if (window.matchMedia('(min-width: 760px)').matches) return;
      msgs[i].removeAttribute('data-active');
      i = (i + 1) % msgs.length;
      msgs[i].setAttribute('data-active', '');
    }, 4200);
  }

  /* ---------- gallery -------------------------------------------------- */
  function gallery() {
    var root = document.querySelector('[data-gallery]');
    if (!root) return;
    var slides = root.querySelector('.gal__slides');
    var thumbs = root.querySelectorAll('.gal__thumb');
    if (!slides) return;

    thumbs.forEach(function (t, idx) {
      t.addEventListener('click', function () {
        slides.scrollTo({ left: slides.clientWidth * idx, behavior: 'smooth' });
      });
    });

    var tick;
    slides.addEventListener('scroll', function () {
      clearTimeout(tick);
      tick = setTimeout(function () {
        var idx = Math.round(slides.scrollLeft / slides.clientWidth);
        thumbs.forEach(function (t, j) {
          t.setAttribute('aria-current', j === idx ? 'true' : 'false');
        });
      }, 90);
    }, { passive: true });
  }

  /* ---------- tier selection and CTA total ---------------------------- *
   * Only runs on the native fallback ladder. When a bundle app owns the
   * ladder the app writes the variant id and the total itself, and this
   * function finds no [data-tier] inputs and does nothing. One ladder
   * per page, never two.                                                 */
  function tiers() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;
    var inputs = form.querySelectorAll('[data-tier]');
    if (!inputs.length) return;

    /* Every product form on the page, the sticky bar included, must carry the
       selected variant. Updating only the form that owns the radios lets the
       sticky CTA add the wrong tier. */
    var idFields = document.querySelectorAll('[data-product-form] [name="id"]');
    var totals = document.querySelectorAll('[data-cta-total]');
    var wases = document.querySelectorAll('[data-cta-was]');

    function apply(input) {
      idFields.forEach(function (f) { f.value = input.value; });
      var price = parseInt(input.dataset.price, 10);
      var was = parseInt(input.dataset.compare || '0', 10);
      totals.forEach(function (el) { el.textContent = money(price); });
      wases.forEach(function (el) {
        if (was > price) { el.textContent = money(was); el.hidden = false; }
        else { el.hidden = true; }
      });
    }

    inputs.forEach(function (i) {
      i.addEventListener('change', function () { if (i.checked) apply(i); });
      if (i.checked) apply(i);
    });
  }

  /* ---------- sticky CTA ---------------------------------------------- */
  function sticky() {
    var bar = document.querySelector('[data-sticky]');
    var anchor = document.querySelector('[data-sticky-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;

    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) bar.removeAttribute('data-show');
        else bar.setAttribute('data-show', '');
      });
    }, { rootMargin: '0px 0px -40% 0px' }).observe(anchor);
  }

  /* ---------- cart ----------------------------------------------------- */
  function cart() {
    var drawer = document.querySelector('[data-drawer]');
    if (!drawer) return;
    var lastFocus = null, busy = false;
    var inertBefore = new Map();
    var status = drawer.querySelector('[data-cart-status]');
    var error = drawer.querySelector('[data-cart-error]');
    var route = window.Shopify.routes.root;
    function open() {
      if (!drawer.hasAttribute('data-open')) {
        lastFocus = document.activeElement;
        document.querySelectorAll('main, .er-nav, .er-foot, .er-brandbar, .er-service-strip').forEach(function(el){inertBefore.set(el,el.inert);el.inert=true;});
      }
      drawer.setAttribute('data-open',''); drawer.setAttribute('aria-hidden','false');
      document.body.style.overflow='hidden';
      drawer.querySelector('button[data-cart-close]').focus();
    }
    function close() {
      drawer.removeAttribute('data-open'); drawer.setAttribute('aria-hidden','true');
      inertBefore.forEach(function(value,el){el.inert=value;}); inertBefore.clear();
      document.body.style.overflow='';
      if(lastFocus && lastFocus.isConnected)lastFocus.focus();
    }
    function json(url, options) {
      return fetch(url,options).then(function(r){return r.json().then(function(b){if(!r.ok)throw new Error(b.description || b.message || 'Please try again.');return b;});});
    }
    function countUpdate(c) {
      document.querySelectorAll('[data-cart-count]').forEach(function(el){el.textContent=c.item_count;el.hidden=c.item_count===0;});
    }
    function refresh() {
      return Promise.all([
        fetch(route+'?section_id=cart-drawer').then(function(r){if(!r.ok)throw new Error('Your cart could not refresh. Please open the full cart.');return r.text();}),
        json(route+'cart.js')
      ]).then(function(results){
        var doc=new DOMParser().parseFromString(results[0],'text/html');
        var next=doc.querySelector('[data-drawer-inner]');
        if(!next)throw new Error('Your cart could not refresh. Please open the full cart.');
        drawer.querySelector('[data-drawer-inner]').innerHTML=next.innerHTML;
        countUpdate(results[1]);return results[1];
      });
    }
    function setBusy(value){busy=value;drawer.querySelector('[data-drawer-inner]').setAttribute('aria-busy',String(value));drawer.querySelectorAll('button[data-cart-change],button[data-cart-add],button[data-cart-upgrade],.er-cart-checkout').forEach(function(b){b.disabled=value;});}
    function showError(err){error.textContent=err.message||'Please try again.';error.hidden=false;status.textContent='';}
    function mutate(path,data,message,focusKey){
      if(busy)return Promise.resolve();setBusy(true);error.hidden=true;status.textContent='Updating your cart…';
      return json(route+path,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(data)})
        .then(refresh).then(function(){status.textContent=message;if(focusKey){var target=Array.from(drawer.querySelectorAll('[data-key]')).find(function(b){return b.dataset.key===focusKey;});(target||drawer.querySelector('button[data-cart-close]')).focus();}else{drawer.querySelector('button[data-cart-close]').focus();}})
        .catch(showError).finally(function(){setBusy(false);});
    }
    document.addEventListener('click',function(e){
      var opener=e.target.closest('[data-cart-open]');
      if(opener){e.preventDefault();open();error.hidden=true;refresh().catch(showError);return;}
      if(!drawer.contains(e.target))return;
      if(e.target.closest('[data-cart-close]')){close();return;}
      var upgrade=e.target.closest('[data-cart-upgrade]');
      if(upgrade){
        e.preventDefault();
        var updates={};
        updates[upgrade.dataset.sourceKey]=0;
        updates[upgrade.dataset.cartUpgrade]=1;
        mutate('cart/update.js',{updates:updates},upgrade.dataset.success);
        return;
      }
      var change=e.target.closest('[data-cart-change]');
      if(change){e.preventDefault();var qty=Number(change.dataset.cartChange);mutate('cart/change.js',{id:change.dataset.key,quantity:qty},qty===0?'Item removed.':'Quantity updated.',change.dataset.key);return;}
      var add=e.target.closest('[data-cart-add]');
      if(add){mutate('cart/add.js',{items:[{id:Number(add.dataset.cartAdd),quantity:1}]},'Added to your routine.');}
    });
    document.addEventListener('keydown',function(e){
      if(!drawer.hasAttribute('data-open'))return;
      if(e.key==='Escape'){close();return;}
      if(e.key!=='Tab')return;
      var f=Array.from(drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled])')).filter(function(el){return el.getClientRects().length;});
      var first=f[0],last=f[f.length-1];if(!first)return;
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
      if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
    });
    document.addEventListener('submit',function(e){
      var form=e.target;if(!form.matches('[data-product-form]')||e.defaultPrevented)return;
      if(!window.fetch)return;
      e.preventDefault();
      var btn=form.querySelector('[type="submit"]');
      if(busy||btn?.disabled)return;
      setBusy(true);if(btn)btn.disabled=true;
      var slot=form.querySelector('[data-form-error]');if(slot)slot.hidden=true;
      error.hidden=true;
      fetch(route+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
        .then(function(r){return r.json().then(function(b){if(!r.ok)throw new Error(b.description||'Unable to add this pack. Please try again.');return b;});})
        .then(function(){return refresh().then(function(){status.textContent='Added to your cart.';open();});})
        .catch(function(err){if(slot){slot.textContent=err.message;slot.hidden=false;}else{open();showError(err);}})
        .finally(function(){setBusy(false);if(btn){var selected=form.querySelector('[name="pack_size"]:checked');btn.disabled=selected?selected.dataset.available!=='true':false;}});
    });
    json(route+'cart.js').then(countUpdate).catch(function(){});
  }

  function init() {
    announcements(); gallery(); tiers(); sticky(); cart();
    function revealContact(){var form=document.getElementById('er-contact');if(form&&location.hash==='#er-contact')form.open=true;}
    window.addEventListener('hashchange',revealContact);revealContact();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();


